export default "__VITE_ASSET__ChrlVIaK__"